import { SuspiciousActivityBadge } from '@/components/ui/SuspiciousActivityBadge';
import { Typography } from '@/components/ui/atoms';
import { CandidateEmailInline } from '../CandidateEmailInline';
import type { CandidatesTableRow } from './candidatesTable.columns';

interface CandidateIdentityCellProps {
  row: CandidatesTableRow;
}

export function CandidateIdentityCell({ row }: CandidateIdentityCellProps) {
  const { candidate, jobId, hasCheatingFlag } = row;

  return (
    <div className="min-w-0">
      <div className="flex items-center gap-2">
        <Typography variant="body-sm" weight="semibold" color="primary" className="truncate">
          {candidate.talentName || 'Unknown'}
        </Typography>
        {hasCheatingFlag && <SuspiciousActivityBadge size="sm" />}
      </div>
      <CandidateEmailInline
        jobId={jobId}
        candidateId={candidate.id}
        hasValidEmail={Boolean(candidate.hasValidEmail)}
        email={candidate.talentEmail}
        stopPropagation
      />
    </div>
  );
}
